import React from "react";
import { SurveyLayouts } from "modules/MainSurveyEditor/helpers/blockForm";
import { getClasses } from "shared/helpers/styleHelper";

export const SurveyLayoutIcon = ({ type }: { type: SurveyLayouts }) => {
  const classes = getClasses({
    "module-survey-layout-icon": true,
    "is-wizard": type === SurveyLayouts.Wizard,
    "is-simple": type === SurveyLayouts.Simple,
  });

  return (
    <div className={classes}>
      {type === SurveyLayouts.Wizard && <div />}
      <div />
    </div>
  );
};
